<template>
  <CModal
      :show.sync="viewQBankModal"
      :centered="true"
      :title="qbank.title"
      size="md"
  >
    <div class="text-right">
      <h6>توضیحات</h6>
      <div class="desc w-100 text-sm">{{ qbank.text }}</div>

      <h6 class="mt-3">دانلود فایل/فایل‌ها</h6>
      <div
          v-for="(file, index) in qbank.files"
          :key="index"
          class="download-file mb-3 ml-2"
      >
        <a :href="file" target="_blank" download="">
          <CIcon name="cil-file"/>
        </a>
      </div>
    </div>

    <template #footer>
      <CButton @click="viewQBankModal = false" color="danger">بستن</CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    qbank: {
      type: Object,
    },
  },
  computed: {
    viewQBankModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.download-file {
  display: inline-block;
  width: 65px;
  height: 65px;
  border: 1px solid #9da5b1;
  color: #9da5b1;
  text-align: center;
  line-height: 65px;
  cursor: pointer;

  border-radius: 8px;

  .c-icon {
    width: 2rem;
    height: 2rem;
  }
}

.desc {
  word-wrap: break-word;
  white-space: pre-line;
  font-size: 14px;
  line-height: 1.5;
}
</style>